'use client';

import { cn } from './cn';
import { FC } from 'react';

interface EyeIconProps {
  className?: string;
  show?: boolean;
}

export const EyeIcon: FC<EyeIconProps> = ({ className, show = true }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 23" fill="none" className={cn('h-full w-full', className)}>
      <circle cx="10.8305" cy="11.2687" r="2.22037" stroke="#111111" strokeWidth="2" />
      <path
        d="M10.855 5.64746C7.61543 5.64746 4.34591 9.40691 3.11609 11.2866C4.14594 13.1764 7.1415 16.9559 10.8849 16.9559C14.6284 16.9559 17.7239 13.1564 18.8038 11.2567C17.504 9.38697 14.0945 5.64746 10.855 5.64746Z"
        stroke="#111111"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      {show && (
        <>
          <line x1="2.84862" y1="15.9096" x2="16.1149" y2="2.64333" stroke="#FCFBFA" strokeWidth="2" />
          <line
            x1="4.86597"
            y1="16.6766"
            x2="16.718"
            y2="4.82455"
            stroke="#111111"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </>
      )}
    </svg>
  );
};
